/* eslint complexity:0 */ // TODO PINT-4748
// uses ./appScreenshots.less
import PropTypes from 'prop-types';
import React, { useState, useEffect } from 'react';
import ImageGallery from 'react-image-gallery';
import { getVideoEmbedUrl, getVideoThumbnailUrl } from '../../../components/videoUtilities';

const AppScreenshots = (props) => {
    const [activeSlideIsVideo, setActiveSlideIsVideo] = useState(false);
    const [fullscreenElement, setFullscreenElement] = useState(null);

    useEffect(() => {
        if (props.video && props.video.length > 0) {
            setActiveSlideIsVideo(true);
        }
    }, [props.video]);

    let imageGallery = React.createRef();
    const renderVideo = (item) => (
        <div className="image-gallery-image">
            <iframe src={item.embedUrl} allowFullScreen />
        </div>
    );
    const onSlideSwitch = (activeIndex) => setActiveSlideIsVideo(activeIndex < videos.length);
    const images = props.images
        ? props.images.map((url) => ({
              original: url,
              thumbnail: url,
              originalClass: 'gallery-image',
              thumbnailClass: 'gallery-thumb',
          }))
        : [];
    const videos = props.video
        ? props.video.map((video) => ({
              embedUrl: getVideoEmbedUrl(video),
              thumbnail: getVideoThumbnailUrl(window, video),
              originalClass: 'gallery-image',
              thumbnailClass: 'gallery-thumb',
              renderItem: renderVideo,
          }))
        : [];

    if (images.length === 0 && videos.length === 0) {
        images.push({
            original: props.logo,
            thumbnail: props.logo,
            originalClass: 'gallery-image',
            thumbnailClass: 'gallery-thumb',
        });
    }

    return (
        <ImageGallery
            ref={(i) => {
                imageGallery = i;
            }}
            items={[...videos, ...images]}
            showPlayButton={false}
            additionalClass="ast-image-gallery"
            useBrowserFullscreen={false}
            showFullscreenButton={!activeSlideIsVideo || !!fullscreenElement}
            onSlide={onSlideSwitch}
            onThumbnailClick={(event, index) => onSlideSwitch(index)}
            onScreenChange={(fullscreenElementCurrent) => {
                if (typeof fullscreenElement === 'object' && fullscreenElementCurrent === null) {
                    imageGallery.exitFullScreen();
                }
                setFullscreenElement(fullscreenElement);
            }}
        />
    );
};

AppScreenshots.propTypes = {
    images: PropTypes.array,
    video: PropTypes.array,
    logo: PropTypes.string,
};

export default AppScreenshots;
